import { render, staticRenderFns } from "./Professions.vue?vue&type=template&id=1d61a79d&scoped=true&"
import script from "./Professions.vue?vue&type=script&lang=js&"
export * from "./Professions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d61a79d",
  null
  
)

export default component.exports